import React, { useEffect, useState } from "react";
import BankSelect from "./BankSelect";

import { useSelector } from "react-redux";
import useApi from "../CustomHooks/useApi";
import bankMaster from '../MasterJson/bank_master.json';

const AddBeneficiaryUniversal = ({
    onSubmit,
    loading = false,
}) => {
    const [mode, setMode] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // All banks from the JSON file
    const allBanks = bankMaster;
    const bankMappings = [
        { short: "SBI", full: "State Bank of India" },
        { short: "PNB", full: "Punjab National Bank" },
        { short: "BOB", full: "BANK OF BARODA" },
        { short: "BOI", full: "BANK OF INDIA" },
        { short: "UBI", full: "UNION BANK OF INDIA" },
        { short: "INDIAN", full: "INDIAN BANK" },
        { short: "CBI", full: "CENTRAL BANK OF INDIA" },
        { short: "CANARA", full: "CANARA BANK" },
        { short: "BOM", full: "BANK OF MAHARASHTRA" },
        { short: "PSB", full: "PUNJAB AND SIND BANK" },
        { short: "IOB", full: "INDIAN OVERSEAS BANK" },
        { short: "UCO", full: "UCO BANK" },
        { short: "AIRTEL", full: "AIRTEL PAYMENTS BANK" },
        { short: "IPPB", full: "INDIA POST PAYMENTS BANK" },
        { short: "HDFC", full: "HDFC Bank" },
        { short: "ICICI", full: "ICICI Bank" },
        { short: "AXIS", full: "Axis Bank" },
        { short: "IDBI", full: "IDBI BANK" },
        { short: "INDUSIND", full: "IndusInd Bank" },
        { short: "KOTAK", full: "Kotak Mahindra Bank" }
    ];


    const highlightedBanks = bankMappings
        .map(item => {
            const bank = allBanks.find(b => {
                const jsonName = b.bank_name?.toLowerCase().trim();
                const mappingName = item.full.toLowerCase().trim();
                return jsonName === mappingName || jsonName.includes(mappingName) || mappingName.includes(jsonName);
            });
            return bank ? { label: item.short, bank } : null;
        })
        .filter(x => x !== null);

    const [bank, setBank] = useState("");
    const [bankCode, setBankCode] = useState("");
    const [ifsc, setIfsc] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [beneficiaryName, setBeneficiaryName] = useState("");
    const [mpin, setMpin] = useState("");

    const [errors, setErrors] = useState({});
    const [showConfirm, setShowConfirm] = useState(false);



    // All banks not in the highlighted list become “Other Banks”
    // const otherBanks = allBanks.filter(
    //     bank => !highlightedBanks.some(hb => hb.bank.bank_code === bank.bank_code)
    // );


    // Allow all banks to appear in the search dropdown
    const otherBanks = allBanks;



    const [showOtherBanks, setShowOtherBanks] = useState(false);
    const [banks, setBanks] = useState([]);


    const handleQuickBankSelect = (bankObj) => {
        setBank(bankObj.bank_name);
        setBankCode(bankObj.bank_code);
        setIfsc(bankObj.ifsc_code_sample || "");
        setErrors((p) => ({ ...p, bank: "", ifsc: "" }));
    };




    const { callApi: getbank } = useApi(
        "/aeps/get/banks",
        "GET"
    );

    const getbanks = async () => {
        try {
            const response = await getbank(
                null,
                `?userId=${userId}`
            );

            if (response?.statuscode === "TXN") {
                setBanks(response?.data || []);
            }

        } catch (error) { }
    };

    useEffect(() => {
        // check2FAStatus();
        getbanks();
    }, []);

    const userId = useSelector(
        (state) => state.auth?.employeeDetails?.userId
    );


    // Map by bank_code (uppercase for safety)
    const bankCodeToIfsc = new Map();
    // Map by normalized bank name (lowercase, trimmed)
    const bankNameToIfsc = new Map();

    bankMaster.forEach(bank => {
        if (bank.bank_code) {
            bankCodeToIfsc.set(bank.bank_code.toUpperCase(), bank.ifsc_code_sample || "");
        }
        if (bank.bank_name) {
            const normalized = bank.bank_name.trim().toLowerCase();
            bankNameToIfsc.set(normalized, bank.ifsc_code_sample || "");
        }
    });
    const getIfscFromMaster = (apiBank) => {
        // Try exact match by bank_code (iin)
        if (apiBank.iin) {
            const ifsc = bankCodeToIfsc.get(apiBank.iin.toUpperCase());
            if (ifsc) return ifsc;
        }
        // Try exact match by name (case-insensitive)
        if (apiBank.name) {
            const normalized = apiBank.name.trim().toLowerCase();
            const ifsc = bankNameToIfsc.get(normalized);
            if (ifsc) return ifsc;
        }
        // Fallback: try partial match for common banks (e.g., "State Bank of India" vs "SBI")
        const lowerName = apiBank.name?.toLowerCase() || "";
        for (let [masterName, ifsc] of bankNameToIfsc.entries()) {
            if (lowerName.includes(masterName) || masterName.includes(lowerName)) {
                console.log("Fuzzy match:", masterName, "->", ifsc);
                return ifsc;
            }
        }
        console.warn("No IFSC found for bank:", apiBank);
        return "";
    };




    /* ================= VALIDATION ================= */
    const validate = (selectedMode) => {
        const err = {};

        if (!bank) err.bank = "Select bank";
        if (!ifsc) err.ifsc = "Enter IFSC";
        // if (!accountNumber || accountNumber.length < 6)
        //     err.accountNumber = "Invalid account number";
        if (!accountNumber || accountNumber.length < 6) {
    err.accountNumber = "Invalid account number";
} else if (!/^[A-Za-z0-9]+$/.test(accountNumber)) {
    err.accountNumber = "Account number can contain only letters and digits";
}

        if (selectedMode === "WITHOUT_VERIFY" && !beneficiaryName) {
            err.beneficiaryName = "Enter beneficiary name";
        }

        if (!/^\d{6}$/.test(mpin)) {
            err.mpin = "Enter valid 6 digit MPIN";
        }

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    /* ================= BUTTON CLICK ================= */
    const handleActionClick = (selectedMode) => {
        setMode(selectedMode);
        if (!validate(selectedMode)) return;
        setShowConfirm(true);
    };

    /* ================= CONFIRM ================= */
    const handleConfirm = () => {
        onSubmit(
            {
                mode,
                bank,
                bankCode,
                ifsc,
                accountNumber,
                beneficiaryName: mode === "VERIFY" ? "" : beneficiaryName,
                account_verify: mode === "VERIFY",
                mpin,
            },
            () => {
                setShowConfirm(false);
            }
        );
    };


    return (
        <>
            <div className="w-full flex justify-center px-3 sm:px-4">
                <div
                    className="
    w-[100%] max-w-full sm:max-w-lg lg:max-w-full
    bg-white rounded-2xl border border-slate-200
    p-0 sm:p-6
    space-y-4 sm:space-y-5
  "
                >

                    {/* ===== BANK ===== */}
                    <div>

                        <div className="col-span-7 px-1 sm:px-4 py-4 ">

                            <h3 className="font-bold text-xl mb-4">
                                Bank Name :
                            </h3>
                            <div className="grid grid-cols-2 min-[400px]:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 sm:gap-3">

                                {highlightedBanks.map(({ label, bank }, index) => {

                                    const colors = [
                                        "bg-blue-700", "bg-red-600", "bg-orange-600", "bg-indigo-900",
                                        "bg-rose-600", "bg-blue-800", "bg-blue-600", "bg-teal-600",
                                        "bg-sky-600", "bg-orange-500", "bg-indigo-700", "bg-green-600",
                                        "bg-purple-600", "bg-cyan-600", "bg-red-500", "bg-orange-700",
                                        "bg-pink-600", "bg-violet-600", "bg-emerald-600", "bg-fuchsia-600"
                                    ];

                                    return (

                                        <button
                                            key={bank.bank_code}
                                            type="button"
                                            onClick={() => handleQuickBankSelect(bank)}
                                            className={`
    h-16 rounded-xl text-white font-bold text-sm shadow leading-tight break-words
    ${colors[index]}
    ${bankCode === bank.bank_code ? "ring-4 ring-green-300" : ""}
    w-full   // 👈 smaller only on laptop
  `}
                                        >
                                            <div className="text-[16px]">{label}</div>

                                            <div className="text-[12px] mt-1 opacity-90">
                                                {/* {bank.name} */}
                                                {bank.bank_name}
                                            </div>
                                        </button>
                                    )
                                })}


                                <button
                                    onClick={() => setShowOtherBanks(!showOtherBanks)}
                                    className="
    h-16 sm:h-16
    rounded-xl
    bg-blue-900
    text-white
    font-bold
    text-xs sm:text-sm
    shadow
    px-1 sm:px-2
    w-auto
  "
                                >
                                    OTHER BANKS
                                </button>
                            </div>



                            {/* {showOtherBanks && (
                                <div className="mt-4">

                                    <select
                                        value={bankCode || ""}
                                        onChange={(e) => {
                                            const selected = allBanks.find(b => b.bank_code === e.target.value);
                                            if (selected) {
                                                setBank(selected.bank_name);
                                                setBankCode(selected.bank_code);
                                                setIfsc(selected.ifsc_code_sample || "");
                                            }
                                            setErrors((p) => ({ ...p, bank: "", ifsc: "" }));
                                        }}
                                        className="w-full h-12 border-2 rounded-lg px-4 text-base"
                                    >
                                        <option>Select Other Bank</option>
                                        {otherBanks.map((b) => (
                                            <option key={b.bank_code} value={b.bank_code}>
                                                {b.bank_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            )} */}

                            {showOtherBanks && (
                                <div className="mt-4 relative">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            setIsDropdownOpen(true);
                                        }}
                                        onFocus={() => setIsDropdownOpen(true)}
                                        // A slight delay on blur allows the onClick event on the list items to fire first
                                        onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)}
                                        placeholder="Search Other Banks..."
                                        className="w-full h-12 border-2 rounded-lg px-4 text-base focus:border-blue-600 outline-none"
                                    />

                                    {isDropdownOpen && (
                                        <ul className="absolute z-10 w-full mt-1 bg-white border-2 border-slate-200 rounded-lg max-h-60 overflow-y-auto shadow-xl">
                                            {otherBanks
                                                .filter((b) => b.bank_name.toLowerCase().includes(searchTerm.toLowerCase()))
                                                .map((b) => (
                                                    <li
                                                        key={b.bank_code}
                                                        onClick={() => {
                                                            setBank(b.bank_name);
                                                            setBankCode(b.bank_code);
                                                            setIfsc(b.ifsc_code_sample || "");
                                                            setSearchTerm(b.bank_name); // Sets the input text to the selected bank
                                                            setIsDropdownOpen(false);
                                                            setErrors((p) => ({ ...p, bank: "", ifsc: "" }));
                                                        }}
                                                        className="px-4 py-3 cursor-pointer hover:bg-slate-100 border-b last:border-none text-sm font-medium text-slate-700 transition-colors"
                                                    >
                                                        {b.bank_name}
                                                    </li>
                                                ))}
                                            
                                            {/* Show a message if no banks match the search */}
                                            {otherBanks.filter((b) => b.bank_name.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 && (
                                                <li className="px-4 py-3 text-slate-500 text-sm">
                                                    No banks found matching "{searchTerm}"
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                </div>
                            )}


                            <div className="mt-4">
                                <label className="text-sm font-medium text-slate-600">
                                    IFSC Code
                                </label>
                                <input
                                    value={ifsc}
                                    onChange={(e) => {
                                        setIfsc(e.target.value.toUpperCase());
                                        setErrors((p) => ({ ...p, ifsc: "" }));
                                    }}

                                    className="mt-1 w-full px-4 py-3 rounded-xl border"
                                    placeholder="Enter IFSC"
                                />
                            </div>

                        </div>



                        {errors.bank && <p className="text-xs text-red-600">{errors.bank}</p>}
                        {errors.ifsc && <p className="text-xs text-red-600">{errors.ifsc}</p>}
                    </div>

                    {/* ===== BENEFICIARY NAME ===== */}
                    {mode === "WITHOUT_VERIFY" && (
                        <div>
                            <label className="text-base sm:text-sm font-semibold font-medium text-slate-600">
                                Beneficiary Name
                            </label>
                            <input
                                className="mt-1 w-full px-4 py-4 text-lg rounded-xl border"
                                value={beneficiaryName}
                                onChange={(e) => setBeneficiaryName(e.target.value)}
                            />
                            {errors.beneficiaryName && (
                                <p className="text-xs text-red-600">
                                    {errors.beneficiaryName}
                                </p>
                            )}
                        </div>
                    )}

                    {/* ===== ACCOUNT NUMBER ===== */}
                    <div>
                        <label className="text-base sm:text-sm font-semibold font-medium text-slate-600">
                            Account Number
                        </label>

                        <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />

                        <input
                            className="mt-1 w-full px-4 py-4 text-lg rounded-xl border"
                            value={accountNumber}
                            type="text"
                            // name="account_number_no_autofill"
                            name="_accoun1t_number1_"
                            // inputMode="numeric"
                            autoComplete="off"
                            // onChange={(e) =>
                            //     setAccountNumber(e.target.value.replace(/\D/g, ""))
                            // }
                            onChange={(e) =>
    setAccountNumber(e.target.value.replace(/[^A-Za-z0-9]/g, ""))
}
                        />
                        {errors.accountNumber && (
                            <p className="text-xs text-red-600">{errors.accountNumber}</p>
                        )}
                    </div>

                    {/* ===== MPIN ===== */}
                    <div>
                        <input type="password" name="fake-pass" autoComplete="new-password" style={{ display: "none" }} />
                        <label className="text-base sm:text-sm font-semibold font-medium text-slate-600">
                            MPIN
                        </label>
                        <input
                            type="password"
                            // name="tpin_no_autofill"
                            name="1__tpin_fiel1d_"
                            inputMode="numeric"
                            autoComplete="off"
                            maxLength={6}
                            className="mt-1 w-full px-4 py-4 text-lg rounded-xl border"
                            value={mpin}
                            onChange={(e) => setMpin(e.target.value.replace(/\D/g, ""))}
                        />
                        {errors.mpin && (
                            <p className="text-xs text-red-600">{errors.mpin}</p>
                        )}
                    </div>

                    {/* ===== BOTTOM BUTTONS (SINGLE LINE) ===== */}
                    <div className="pt-4 border-t">
                        <div className="flex gap-3">
                            <button
                                type="button"
                                onClick={() => handleActionClick("VERIFY")}
                                // className="flex-1 py-3 rounded-xl font-semibold bg-indigo-600 text-white"
                                className="flex-1 py-4 text-lg rounded-2xl font-bold  bg-[#12345A] 
    hover:bg-[#0F2E47]  text-white"
                            >
                                Verify & Add (₹3)
                            </button>

                            <button
                                type="button"
                                onClick={() => handleActionClick("WITHOUT_VERIFY")}
                                // className="flex-1 py-3 rounded-xl font-semibold bg-red-600 text-white hover:bg-red-700"
                                className="flex-1 py-4 text-lg rounded-2xl font-bold  text-white  bg-[#12345A] 
    hover:bg-[#0F2E47] "
                            >
                                Add Without Verify (₹0)
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ===== MODAL CONFIRM POPUP ===== */}
            {showConfirm && (
                <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center">
                    <div className="bg-white w-full sm:max-w-md
            rounded-t-2xl sm:rounded-2xl p-5 sm:p-6 space-y-4">

                        <h3 className="text-base sm:text-lg font-semibold text-slate-800">
                            Confirmation
                        </h3>

                        <p className="text-sm text-slate-700 leading-relaxed">
                            {mode === "VERIFY" ? (
                                <>
                                    <b>English:</b><br />
                                    <strong>₹3</strong> will be deducted for beneficiary account verification.
                                    <br /><br />
                                    <b>हिंदी:</b><br />
                                    लाभार्थी के खाते के सत्यापन के लिए <strong>₹3</strong> काटे जाएंगे।
                                </>
                            ) : (
                                <>
                                    <b>English:</b><br />
                                    <strong>₹0</strong> will be deducted for adding beneficiary without verification.
                                    <br /><br />
                                    <b>हिंदी:</b><br />
                                    बिना सत्यापन के लाभार्थी जोड़ने पर कोई शुल्क नहीं लगेगा।
                                </>
                            )}
                        </p>

                        <div className="flex gap-3 pt-2">
                            <button
                                onClick={() => setShowConfirm(false)}
                                // className="w-full py-3 rounded-xl bg-slate-200"
                                className="flex-1 py-4 text-lg rounded-2xl font-bold"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirm}
                                disabled={loading}
                                // className="w-full py-3 rounded-xl bg-indigo-600 text-white"
                                className="flex-1 py-4 text-lg rounded-2xl font-bold"
                            >
                                {loading ? "Processing..." : "OK"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddBeneficiaryUniversal;






// import React, { useEffect, useState, useRef } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../CustomHooks/useApi";
// import bankMaster from '../MasterJson/bank_master.json';

// const AddBeneficiaryUniversal = ({
//     onSubmit,
//     loading = false,
// }) => {
//     const [mode, setMode] = useState(null);

//     // All banks from the JSON file
//     const allBanks = bankMaster;
//     const bankMappings = [
//         { short: "SBI", full: "State Bank of India" },
//         { short: "PNB", full: "Punjab National Bank" },
//         { short: "BOB", full: "BANK OF BARODA" },
//         { short: "BOI", full: "BANK OF INDIA" },
//         { short: "UBI", full: "UNION BANK OF INDIA" },
//         { short: "INDIAN", full: "INDIAN BANK" },
//         { short: "CBI", full: "CENTRAL BANK OF INDIA" },
//         { short: "CANARA", full: "CANARA BANK" },
//         { short: "BOM", full: "BANK OF MAHARASHTRA" },
//         { short: "PSB", full: "PUNJAB AND SIND BANK" },
//         { short: "IOB", full: "INDIAN OVERSEAS BANK" },
//         { short: "UCO", full: "UCO BANK" },
//         { short: "AIRTEL", full: "AIRTEL PAYMENTS BANK" },
//         { short: "IPPB", full: "INDIA POST PAYMENTS BANK" },
//         { short: "HDFC", full: "HDFC Bank" },
//         { short: "ICICI", full: "ICICI Bank" },
//         { short: "AXIS", full: "Axis Bank" },
//         { short: "IDBI", full: "IDBI BANK" },
//         { short: "INDUSIND", full: "IndusInd Bank" },
//         { short: "KOTAK", full: "Kotak Mahindra Bank" }
//     ];

//     const highlightedBanks = bankMappings
//         .map(item => {
//             const bank = allBanks.find(b => {
//                 const jsonName = b.bank_name?.toLowerCase().trim();
//                 const mappingName = item.full.toLowerCase().trim();
//                 return jsonName === mappingName || jsonName.includes(mappingName) || mappingName.includes(jsonName);
//             });
//             return bank ? { label: item.short, bank } : null;
//         })
//         .filter(x => x !== null);

//     const [bank, setBank] = useState("");
//     const [bankCode, setBankCode] = useState("");
//     const [ifsc, setIfsc] = useState("");
//     const [accountNumber, setAccountNumber] = useState("");
//     const [beneficiaryName, setBeneficiaryName] = useState("");
//     const [mpin, setMpin] = useState("");

//     const [errors, setErrors] = useState({});
//     const [showConfirm, setShowConfirm] = useState(false);

//     // All banks not in the highlighted list become “Other Banks”
//     const otherBanks = allBanks.filter(
//         bank => !highlightedBanks.some(hb => hb.bank.bank_code === bank.bank_code)
//     );

//     const [showOtherBanks, setShowOtherBanks] = useState(false);
//     const [banks, setBanks] = useState([]);

//     // ✅ NEW STATE FOR SEARCHABLE DROPDOWN
//     const [searchQuery, setSearchQuery] = useState("");
//     const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//     const dropdownRef = useRef(null);

//     // ✅ CLICK OUTSIDE LOGIC to close the dropdown
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setIsDropdownOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const handleQuickBankSelect = (bankObj) => {
//         setBank(bankObj.bank_name);
//         setBankCode(bankObj.bank_code);
//         setIfsc(bankObj.ifsc_code_sample || "");
//         setSearchQuery(""); // Reset search if they click a quick bank
//         setErrors((p) => ({ ...p, bank: "", ifsc: "" }));
//     };

//     const { callApi: getbank } = useApi(
//         "/aeps/get/banks",
//         "GET"
//     );

//     const userId = useSelector(
//         (state) => state.auth?.employeeDetails?.userId
//     );

//     const getbanks = async () => {
//         try {
//             const response = await getbank(
//                 null,
//                 `?userId=${userId}`
//             );

//             if (response?.statuscode === "TXN") {
//                 setBanks(response?.data || []);
//             }
//         } catch (error) { }
//     };

//     useEffect(() => {
//         getbanks();
//     }, []);

//     // Filter banks based on search query
//     const filteredOtherBanks = otherBanks.filter(b =>
//         b.bank_name.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     /* ================= VALIDATION ================= */
//     // const validate = (selectedMode) => {
//     //     const err = {};

//     //     if (!bank) err.bank = "Select bank";
//     //     if (!ifsc) err.ifsc = "Enter IFSC";
//     //     if (!accountNumber || accountNumber.length < 6)
//     //         err.accountNumber = "Invalid account number";

//     //     if (selectedMode === "WITHOUT_VERIFY" && !beneficiaryName) {
//     //         err.beneficiaryName = "Enter beneficiary name";
//     //     }

//     //     if (!/^\d{6}$/.test(mpin)) {
//     //         err.mpin = "Enter valid 6 digit MPIN";
//     //     }

//     //     setErrors(err);
//     //     return Object.keys(err).length === 0;
//     // };
//     const validate = (selectedMode) => {
//     const err = {};

//     if (!bank) err.bank = "Select bank";
//     if (!ifsc) err.ifsc = "Enter IFSC";
//     if (!accountNumber || accountNumber.length < 6)
//         err.accountNumber = "Invalid account number";

//     // ONLY fails if mode is WITHOUT_VERIFY and the field is empty
//     if (selectedMode === "WITHOUT_VERIFY" && !beneficiaryName.trim()) {
//         err.beneficiaryName = "Enter beneficiary name";
//     }

//     if (!/^\d{6}$/.test(mpin)) {
//         err.mpin = "Enter valid 6 digit MPIN";
//     }

//     setErrors(err);
//     return Object.keys(err).length === 0;
// };


//     /* ================= BUTTON CLICK ================= */
//     const handleActionClick = (selectedMode) => {
//         setMode(selectedMode);
//         if (!validate(selectedMode)) return;
//         setShowConfirm(true);
//     };

//     /* ================= CONFIRM ================= */
//     const handleConfirm = () => {
//         onSubmit(
//             {
//                 mode,
//                 bank,
//                 bankCode,
//                 ifsc,
//                 accountNumber,
//                 // beneficiaryName: mode === "VERIFY" ? "" : beneficiaryName,
//                 beneficiaryName: beneficiaryName,
//                 account_verify: mode === "VERIFY",
//                 mpin,
//             },
//             () => {
//                 setShowConfirm(false);
//             }
//         );
//     };

//     return (
//         <>
//             <div className="w-full flex justify-center px-3 sm:px-4">
//                 <div className="w-[100%] max-w-full sm:max-w-lg lg:max-w-full bg-white rounded-2xl border border-slate-200 p-0 sm:p-6 space-y-4 sm:space-y-5">

                    
//       <div className="mb-3 text-start">
//         <h2 className="text-2xl sm:text-2xl font-extrabold text-slate-900">
//           Add New Beneficiary
//         </h2>
//       </div> 


//                      {/* ===== ACCOUNT NUMBER ===== */}
//                     {/* <div className="flex ">
                        
//                         <label className="text-base sm:text-sm font-semibold text-slate-600 w-[23%]">Account Number</label>
                        
//                         <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
//                         <input
//                             className="mt-1 w-[70%] px-4 py-4 text-lg rounded-xl border"
//                             value={accountNumber}
//                             type="text"
//                             name="_accoun1t_number1_"
//                             inputMode="numeric"
//                             autoComplete="off"
//                             onChange={(e) => setAccountNumber(e.target.value.replace(/\D/g, ""))}
//                             placeholder="Bank Account Number"
//                         />
//                         {errors.accountNumber && <p className="text-xs text-red-600">{errors.accountNumber}</p>}
//                     </div> */}
//                      <div className="flex flex-col md:flex-row md:items-center mb-4">
//                         <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
//                             Account Number
//                         </label>
//                         <div className="w-full md:w-[77%] flex flex-col">
//                             <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
//                             <input
//                                 className="w-full px-4 py-4 text-lg rounded-xl border border-slate-400"
//                                 value={accountNumber}
//                                 type="text"
//                                 name="_accoun1t_number1_"
//                                 inputMode="numeric"
//                                 autoComplete="off"
//                                 onChange={(e) => setAccountNumber(e.target.value.replace(/\D/g, ""))}
//                                 placeholder="Bank Account Number"
//                             />
//                             {errors.accountNumber && <p className="text-xs text-red-600 mt-1">{errors.accountNumber}</p>}
//                         </div>
//                     </div>

                    
//                     {/* ===== BANK ===== */}
//                     <div>
//                         {/* <div className="col-span-7 px-1 sm:px-0 py-4 overflow-hidden"> */}
//                         <div className="col-span-7 px-1 sm:px-0 py-4 overflow-visible relative">
//                            {/* <div className="flex "> */}
//                            <div className="flex flex-col md:flex-row md:items-start">
//                             {/* <h3 className="font-bold text-lg mb-4 w-[30%] bg-red-600">Bank Name</h3> */}
//                             <h3 className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0 pt-2">Bank Name</h3>
                            
//                             {/* <div> */}
//                             <div className="w-full md:w-[77%]">
                                
//                             <div className="grid grid-cols-2 min-[400px]:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 sm:gap-1">

//                                 {highlightedBanks.map(({ label, bank }, index) => {
//                                     const colors = [
//                                         "bg-blue-700", "bg-red-600", "bg-orange-600", "bg-indigo-900",
//                                         "bg-rose-600", "bg-blue-800", "bg-blue-600", "bg-teal-600",
//                                         "bg-sky-600", "bg-orange-500", "bg-indigo-700", "bg-green-600",
//                                         "bg-purple-600", "bg-cyan-600", "bg-red-500", "bg-orange-700",
//                                         "bg-pink-600", "bg-violet-600", "bg-emerald-600", "bg-fuchsia-600"
//                                     ];

//                                     return (
//                                         <button
//                                             key={bank.bank_code}
//                                             type="button"
//                                             onClick={() => handleQuickBankSelect(bank)}
//                                             className={`h-16 rounded-[3px] text-white font-bold text-sm shadow leading-tight break-words ${colors[index]} ${bankCode === bank.bank_code ? "ring-4 ring-green-300" : ""} w-full`}
//                                         >
//                                             <div>{label}</div>
//                                             <div className="text-[10px] mt-1 opacity-90">
//                                                 {bank.bank_name}
//                                             </div>
//                                         </button>
//                                     )
//                                 })}

//                                 <button
//                                     onClick={() => setShowOtherBanks(!showOtherBanks)}
//                                     className="h-16 sm:h-16 rounded-[3px] bg-blue-900 text-white font-bold text-xs sm:text-sm shadow px-1 sm:px-2 w-auto"
//                                 >
//                                     OTHER BANKS
//                                 </button>
//                             </div>
//                                     {errors.bank && <p className="text-xs text-red-600 py-4">{errors.bank}</p>}

//                             {/* ✅ CUSTOM SEARCHABLE DROPDOWN */}
//                             {showOtherBanks && (
//                                 <div className="mt-4 relative" ref={dropdownRef}>
//                                     <input
//                                         type="text"
//                                         placeholder="Type to search other banks..."
//                                         value={searchQuery}
//                                         onChange={(e) => {
//                                             setSearchQuery(e.target.value);
//                                             setIsDropdownOpen(true);
//                                         }}
//                                         onFocus={() => setIsDropdownOpen(true)}
//                                         className="w-full h-12 border border-slate-400 rounded-lg px-4 mb-4 text-base focus:border-indigo-600 focus:outline-none"
//                                     />

//                                     {isDropdownOpen && (
//                                         <div className="absolute z-50 w-full mt-1 bg-white border border-slate-400 rounded-lg shadow-2xl max-h-60 overflow-y-auto">
//                                             {filteredOtherBanks.length > 0 ? (
//                                                 filteredOtherBanks.map((b) => (
//                                                     <div
//                                                         key={b.bank_code}
//                                                         onClick={() => {
//                                                             // When user clicks a bank from the list:
//                                                             setBank(b.bank_name);
//                                                             setBankCode(b.bank_code);
//                                                             setIfsc(b.ifsc_code_sample || "");
//                                                             setSearchQuery(b.bank_name); // Put the selected name in the input
//                                                             setIsDropdownOpen(false); // Close dropdown
//                                                             setErrors((p) => ({ ...p, bank: "", ifsc: "" }));
//                                                         }}
//                                                         className="px-4 py-3 hover:bg-slate-100 cursor-pointer text-slate-700 border-b last:border-b-0 text-sm font-medium"
//                                                     >
//                                                         {b.bank_name}
//                                                     </div>
//                                                 ))
//                                             ) : (
//                                                 <div className="px-4 py-3 text-slate-500 text-sm">No banks found matching "{searchQuery}"</div>
//                                             )}
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
                            
//                             </div>
//                             </div>

//                             {/* <div className="mt-4 flex "> */}
//                             {/* <div className="mt-4 flex flex-col md:flex-row md:items-center">
//                                 <label className="text-sm font-medium text-slate-600 md:w-[23%] shrink-0">IFSC Code</label>
//                                 <input
//                                     value={ifsc}
//                                     onChange={(e) => {
//                                         setIfsc(e.target.value.toUpperCase());
//                                         setErrors((p) => ({ ...p, ifsc: "" }));
//                                     }}
//                                     className="mt-1 w-full md:w-[77%] px-4 py-3 rounded-xl border border-slate-400 "
//                                     placeholder="Enter IFSC"
//                             />        
                            
//                          {errors.ifsc ? <p className="text-xs text-red-600 py-4  ">{errors.ifsc}</p> :" Enter IFSC"}  
//                             </div> */}
//                             <div className="mt-4 flex flex-col md:flex-row md:items-center ">
//     <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
//         IFSC Code
//     </label>
//     <div className="w-full md:w-[77%] flex flex-col">
//         <input
//             value={ifsc}
//             onChange={(e) => {
//                 setIfsc(e.target.value.toUpperCase());
//                 setErrors((p) => ({ ...p, ifsc: "" }));
//             }}
//             className="w-full px-4 py-3 rounded-xl border border-slate-400"
//             placeholder="Enter IFSC"
//         />
//         {errors.ifsc && <p className="text-xs text-red-600 mt-1">{errors.ifsc}</p>}
//     </div>
// </div>
//                         </div>

//                         {/* {errors.bank && <p className="text-xs text-red-600 px-4">{errors.bank}</p>} */}
//                     </div>


//                     {/* ===== BENEFICIARY NAME ===== */}
//                     {/* {mode === "WITHOUT_VERIFY" && (
//     <div className="flex flex-col md:flex-row md:items-center mb-4">
//         <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
//             Beneficiary Name
//         </label>
//         <div className="w-full md:w-[77%] flex flex-col">
//             <input
//                 className="w-full px-4 py-4 text-lg rounded-xl border border-slate-400"
//                 value={beneficiaryName} 
//                 placeholder="Beneficiary Name"
//                 onChange={(e) => setBeneficiaryName(e.target.value)}
//             />
//             {errors.beneficiaryName && <p className="text-xs text-red-600 mt-1">{errors.beneficiaryName}</p>}
//         </div>
//     </div>
// )} */}
// {/* ===== BENEFICIARY NAME ===== */}
// <div className="flex flex-col md:flex-row md:items-center mb-4">
//     <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
//         Beneficiary Name
//     </label>
//     <div className="w-full md:w-[77%] flex flex-col">
//         <input
//             className="w-full px-4 py-4 text-lg rounded-xl border border-slate-400"
//             value={beneficiaryName} 
//             placeholder="Enter Beneficiary Name"
//             onChange={(e) => {
//                 setBeneficiaryName(e.target.value);
//                 // Clear error as user types
//                 if (errors.beneficiaryName) setErrors((p) => ({ ...p, beneficiaryName: "" })); 
//             }}
//         />
//         {errors.beneficiaryName && <p className="text-xs text-red-600 mt-1">{errors.beneficiaryName}</p>}
//     </div>
// </div>
//                     {/* ===== ACCOUNT NUMBER ===== */}
//                     {/* <div>
//                         <label className="text-base sm:text-sm font-semibold text-slate-600">Account Number</label>
//                         <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
//                         <input
//                             className="mt-1 w-full px-4 py-4 text-lg rounded-xl border"
//                             value={accountNumber}
//                             type="text"
//                             name="_accoun1t_number1_"
//                             inputMode="numeric"
//                             autoComplete="off"
//                             onChange={(e) => setAccountNumber(e.target.value.replace(/\D/g, ""))}
//                         />
//                         {errors.accountNumber && <p className="text-xs text-red-600">{errors.accountNumber}</p>}
//                     </div> */}

//                     {/* ===== MPIN ===== */}
//                     {/* <div className="flex gap-[14vw]"> */}
//                   <div className="flex flex-col md:flex-row md:items-center mb-4">
//     <label className="text-base sm:text-sm font-semibold text-slate-600 mb-2 md:mb-0 md:w-[23%] shrink-0">
//         MPIN
//     </label>
//     <div className="w-full md:w-[77%] flex flex-col">
//         <input type="password" name="fake-pass" autoComplete="new-password" style={{ display: "none" }} />
//         <input
//             type="password"
//             name="1__tpin_fiel1d_"
//             inputMode="numeric"
//             autoComplete="off"
//             maxLength={6}
//             className="w-full px-4 py-4 text-lg rounded-xl border border-slate-400"
//             value={mpin}
//             onChange={(e) => setMpin(e.target.value.replace(/\D/g, ""))}
//             placeholder="Enter MPIN Here"
//         />
//         {errors.mpin && <p className="text-xs text-red-600 mt-1">{errors.mpin}</p>}
//     </div>
// </div>
//                     {/* ===== BOTTOM BUTTONS ===== */}
//                     <div className="pt-4 border ">
//                         <div className="flex gap-3">
//                             <button
//                                 type="button"
//                                 onClick={() => handleActionClick("VERIFY")}
//                                 className="flex py-4 px-10 text-lg rounded-2xl font-bold bg-[#12345A] hover:bg-[#0F2E47] text-white"
//                             >
//                                 Verify & Add (₹3)
//                             </button>
//                             <button
//                                 type="button"
//                                 onClick={() => handleActionClick("WITHOUT_VERIFY")}
//                                 className="flex py-4 px-4 text-lg rounded-2xl font-bold text-white bg-[#12345A] hover:bg-[#0F2E47]"
//                             >
//                                 Add Without Verify (₹0)
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* ===== MODAL CONFIRM POPUP ===== */}
//             {showConfirm && (
//                 <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center">
//                     <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 sm:p-6 space-y-4">
//                         <h3 className="text-base sm:text-lg font-semibold text-slate-800">Confirmation</h3>
//                         <p className="text-sm text-slate-700 leading-relaxed">
//                             {mode === "VERIFY" ? (
//                                 <>
//                                     <b>English:</b><br />
//                                     <strong>₹3</strong> will be deducted for beneficiary account verification.<br /><br />
//                                     <b>हिंदी:</b><br />
//                                     लाभार्थी के खाते के सत्यापन के लिए <strong>₹3</strong> काटे जाएंगे।
//                                 </>
//                             ) : (
//                                 <>
//                                     <b>English:</b><br />
//                                     <strong>₹0</strong> will be deducted for adding beneficiary without verification.<br /><br />
//                                     <b>हिंदी:</b><br />
//                                     बिना सत्यापन के लाभार्थी जोड़ने पर कोई शुल्क नहीं लगेगा।
//                                 </>
//                             )}
//                         </p>
//                         <div className="flex gap-3 pt-2">
//                             <button onClick={() => setShowConfirm(false)} className="flex-1 py-4 text-lg rounded-2xl font-bold">
//                                 Cancel
//                             </button>
//                             <button onClick={handleConfirm} disabled={loading} className="flex-1 py-4 text-lg rounded-2xl font-bold">
//                                 {loading ? "Processing..." : "OK"}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default AddBeneficiaryUniversal;